import { Location } from '@angular/common';
import { Injectable } from '@angular/core';
import { CURRENT_USER } from 'src/app/core/constants/local-storage-keys';
import { Environment, SsoConfig } from 'th-env';

/**
 * Used for reading values stored in the window object from the /assets/js/env.js file
 * and exposing them in a DI aware Angular service.
 */
@Injectable({
  providedIn: 'root'
})
export class EnvironmentService {
  private environment: Environment;

  public get apiBaseUrl(): string {
    return this.environment.apiBaseUrl || '';
  }

  public get loginUrl(): '/login' | '/login-legacy' {
    return this.environment.loginUrl || '/login';
  }

  public get logo(): string {
    return this.environment.logo || '';
  }

  public get enableInternetConnectionCheck(): boolean {
    return this.environment.enableInternetConnectionCheck || false;
  }

  public get currentUserLocalStorageKey(): string {
    return `${CURRENT_USER}${this.apiBaseUrl}`;
  }

  public get idleName(): string {
    return `main${this.apiBaseUrl}`;
  }

  public get ssoConfig(): SsoConfig {
    return this.environment.ssoConfig;
  }

  constructor(location: Location) {
    this.environment = (window || {})['__env__'] || {};

    if (this.environment.ssoConfig?.oidc) {
      this.environment.ssoConfig.oidc.redirectUri =
        window.location.origin + location.prepareExternalUrl('/login/callback');
    }
  }
}
